// extracted by mini-css-extract-plugin
export default {"container":"styles_container__jMELh","maxWidthContainer":"styles_maxWidthContainer__ngdI7","testimonialSlide":"styles_testimonialSlide__YGKOU"};